<template>
  <div class="mt-3">
    <div v-if="object.published_at">
      <vue-good-table
        :rows="alerts"
        :columns="tableColumns"
        @on-row-click="({row}) => $router.push({name: 'alerts.view', params: {alertId: row.id}})"
        styleClass="vgt-table"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'status'">
            <span
              v-if="props.row.sent_at"
              class="text-success"
            >
              &#x25cf;
              Sent
              <span v-date="{ date: props.row.sent_at, timeAgo: true }" />
            </span>
            <span
              v-else
              class="text-warning"
            >
              &#x25cf;
              Sending
              <span v-date="{ date: props.row.send_at, timeAgo: true }" />
            </span>
          </span>
          <span v-else>{{props.formattedRow[props.column.field]}}</span>
        </template>
      </vue-good-table>

      <div
        v-if="$login.can('alerts.create')"
        class="d-flex mt-3"
      >
        <router-link
          class="btn btn-primary ml-auto"
          :to="{
            name: 'alerts.create',
            params: {
              id: this.object.id,
              type: this.type.substr(0, this.type.length-1),
            },
          }"
        >
          Create new alert
        </router-link>
      </div>
    </div>
    <div v-else>
      Still processing
    </div>
  </div>
</template>

<script>
import Date from '@/directives/date'
import {get} from '@/helpers'
import {VueGoodTable} from 'vue-good-table'

export default {
  components: {
    VueGoodTable,
  },
  props: {
    object: {
      required: true,
      type: Object,
    },
  },

  directives: {
    Date,
  },

  data () {
    return {
      alerts: [],
      tableColumns: [
        {
          label: 'Subject',
          field: 'subject',
        },
        {
          label: 'Status',
          field: 'status',
        },
      ]
    }
  },

  watch: {
    object: {
      deep: true,
      handler () {
        this.getAlerts()
      },
    },
  },

  computed: {
    type () {
      return this.object.title ? 'articles' : 'newsletters'
    },
  },

  mounted () {
    this.getAlerts()
  },

  methods: {
    getAlerts () {
      get(`${this.type}/${this.object.id}/alerts`).then(this.gotAlerts)
    },
    gotAlerts ({data: {data}}) {
      this.alerts = data
    },
  },
}
</script>

